import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextAreaSF from '../../../widgets/form/InputTextAreaSF'

const ChatMessageReplyModalUI = ({ context, successMsg, errorList, setErrorList,
  replyMode, submitted, onSubmit, onCancelClick,
  message, onMessageChange, messageError, setMessageError
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Reply Message'
    buttonLabel='Send'
    cancelLabel='Cancel'
    isOpen={replyMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextAreaSF type='text' name='message' label='Message'
      required={true} maxLength={1000}
      value={message} onChange={onMessageChange}
      error={messageError} setError={setMessageError}
    />
  </ModalFormUI>

export default ChatMessageReplyModalUI
